"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GithubStats = void 0;
var node_fetch_1 = __importStar(require("node-fetch"));
/**
 * Class representing an error message returned from the GitHub API.
 */
var GithubError = /** @class */ (function (_super) {
    __extends(GithubError, _super);
    function GithubError(message) {
        var _this = _super.call(this, message) || this;
        _this.name = 'GithubError';
        return _this;
    }
    return GithubError;
}(Error));
/**
 * Class for interacting with the GitHub API.
 */
var GithubStats = /** @class */ (function () {
    /**
     * Create an object for interacting with the GitHub API.
     *
     * @param repoOwner - Repository owner
     * @param repoName - Repository name
     * @param token - GitHub API token
     */
    function GithubStats(repoOwner, repoName, token) {
        if (token === void 0) { token = ''; }
        this.repoOwner = repoOwner;
        this.repoName = repoName;
        if (typeof self === 'undefined') {
            this.token = token || process.env.GITHUB_TOKEN || '';
        }
        else {
            /* istanbul ignore next */
            this.token = token;
        }
    }
    /**
     * Fetch the list of releases.
     *
     * @returns A promise to the list of releases
     */
    GithubStats.prototype.getAllReleases = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "https://api.github.com/repos/" + this.repoOwner + "/" + this.repoName + "/releases?per_page=100";
                        return [4 /*yield*/, this.fetch(url)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    /**
     * Fetch a single release.
     *
     * @param tag - The name of the release tag
     * @returns A promise to the release by the `tag`
     */
    GithubStats.prototype.getRelease = function (tag) {
        return __awaiter(this, void 0, void 0, function () {
            var url, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "https://api.github.com/repos/" + this.repoOwner + "/" + this.repoName + "/releases/tags/" + tag;
                        return [4 /*yield*/, this.fetch(url)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response[0]];
                }
            });
        });
    };
    /**
     * Fetch the latest release.
     *
     * @returns A promise to the latest release
     */
    GithubStats.prototype.getLatestRelease = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "https://api.github.com/repos/" + this.repoOwner + "/" + this.repoName + "/releases/latest";
                        return [4 /*yield*/, this.fetch(url)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response[0]];
                }
            });
        });
    };
    /**
     * Fetch the total number of downloads for all releases.
     *
     * @returns A promise to the number of downloads
     */
    GithubStats.prototype.getTotalDownloads = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAllReleases()];
                    case 1: return [2 /*return*/, (_a.sent()).reduce(function (acc, release) {
                            return acc + release.assets.reduce(function (acc, asset) {
                                return acc + asset.download_count;
                            }, 0);
                        }, 0)];
                }
            });
        });
    };
    /**
     * Fetch the number of downloads for a single release.
     *
     * @param tag - The name of the release tag
     * @returns A promise to the number of downloads
     */
    GithubStats.prototype.getReleaseDownloads = function (tag) {
        return __awaiter(this, void 0, void 0, function () {
            var release;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getRelease(tag)];
                    case 1:
                        release = _a.sent();
                        return [2 /*return*/, release.assets.reduce(function (acc, asset) { return acc + asset.download_count; }, 0)];
                }
            });
        });
    };
    /**
     * Fetch the number of downloads for the latest release.
     *
     * @returns A promise to the number of downloads
     */
    GithubStats.prototype.getLatestReleaseDownloads = function () {
        return __awaiter(this, void 0, void 0, function () {
            var release;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getLatestRelease()];
                    case 1:
                        release = _a.sent();
                        return [2 /*return*/, release.assets.reduce(function (acc, asset) { return acc + asset.download_count; }, 0)];
                }
            });
        });
    };
    /**
     * Fetch data from the GitHub API. Pagination is also supported.
     *
     * @param url - URL to a GitHub API endpoint
     * @returns A promise to the list of releases
     */
    GithubStats.prototype.fetch = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            var result, headers, response, _a, match, _b, _c, _d, _e, _f, _g;
            return __generator(this, function (_h) {
                switch (_h.label) {
                    case 0:
                        result = [];
                        headers = new node_fetch_1.Headers();
                        if (typeof self === 'undefined') {
                            headers.append('User-Agent', 'github-release-stats');
                        }
                        if (this.token) {
                            headers.append('Authorization', "token " + this.token);
                        }
                        return [4 /*yield*/, node_fetch_1.default(url, {
                                method: 'GET',
                                headers: headers,
                            })];
                    case 1:
                        response = _h.sent();
                        if (!!response.ok) return [3 /*break*/, 3];
                        _a = GithubError.bind;
                        return [4 /*yield*/, response.json()];
                    case 2: throw new (_a.apply(GithubError, [void 0, (_h.sent()).message]))();
                    case 3:
                        if (!response.headers.has('link')) return [3 /*break*/, 5];
                        match = response.headers.get('link').match(/^.*<(.*)>; rel="next"/);
                        if (!match) return [3 /*break*/, 5];
                        _c = 
                        // Fetch next page
                        (_b = result.push).apply;
                        _d = [
                            // Fetch next page
                            result];
                        return [4 /*yield*/, this.fetch(match[1])];
                    case 4:
                        // Fetch next page
                        _c.apply(_b, _d.concat([_h.sent()]));
                        _h.label = 5;
                    case 5:
                        _f = (_e = result.unshift).apply;
                        _g = [result];
                        return [4 /*yield*/, response.json()];
                    case 6:
                        _f.apply(_e, _g.concat([[_h.sent()].flat()]));
                        return [2 /*return*/, result];
                }
            });
        });
    };
    return GithubStats;
}());
exports.GithubStats = GithubStats;
